import { StaffAccessLevels } from "@/enums/StaffAccessLevels"
import { accessMatrix } from "./accessMatrix";
import { AccessMatrixKeys } from "./accessMatrixKeysEnum";

export const hasAccess = (userAccessLevel: StaffAccessLevels, actionKey: AccessMatrixKeys): boolean => {
  const allowedRoles = accessMatrix[actionKey]
  return allowedRoles ? allowedRoles.includes(userAccessLevel) : false
}